const firebaseConfig = {
    apiKey: "AIzaSyDNhX7-zLYF1iNuF3EsHRiFW1TR203J3qc",
    authDomain: "volunteer-network-b39a7.firebaseapp.com",
    databaseURL: "https://volunteer-network-b39a7.firebaseio.com",
    projectId: "volunteer-network-b39a7",
    storageBucket: "volunteer-network-b39a7.appspot.com",
    messagingSenderId: "439196947351",
    appId: "1:439196947351:web:32bdda04b8b41b36fd6ad2"
  };

  export default firebaseConfig;